import React from 'react'
import { useIntl } from 'react-intl'
import { toast } from 'react-toastify'
import { LinearProgress } from '@mui/material'
import { userApiSlice } from '../../../features/user/userSlice'
import { H3 } from '../../../layouts/TextStyles'
import { managerApi } from '../../../features/manager/manager'
import { MODERATOR, SELLER } from '../../../utils/constants'
import ManagersTable from './components/ManagersTable'
import AddManagerDialog from './components/AddManagerDialog'
import Sentinel from '../../../components/infiniteScroll/Sentinel'
import { usePaginatedList } from '../../../app/hooks/usePaginatedList'
import { Content, Header, Title, Wrapper } from './styles'

const ManagerListPage = () => {
    const { formatMessage } = useIntl()
    const [fetchManagers] = managerApi.useLazyFetchAllManagersQuery()
    const [deleteManager, { isLoading: isDeleting }] =
        managerApi.useDeleteManagerMutation()
    const [resetTemporaryPassword, { isLoading: isReseting }] =
        userApiSlice.useResetTemporaryPasswordMutation()

    const { rows, isLoading, loadedPages, sentinelRef, reload } =
        usePaginatedList(
            (page, size) =>
                fetchManagers({ page, size, roles: [SELLER, MODERATOR] }).unwrap(),
            [],
        )

    const handleDelete = async (id: number) => {
        try {
            await deleteManager(id).unwrap()
            toast.success(formatMessage({ id: 'deletedSuccess' }))
            reload()
        } catch (error) {}
    }

    const handleResetPassword = async (id: number) => {
        try {
            await resetTemporaryPassword(id).unwrap()
            toast.success(formatMessage({ id: 'savedSuccess' }))
            reload()
        } catch (error) {}
    }

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'managers' })}</H3>
                    </Title>

                    <AddManagerDialog />
                </Header>

                {(isLoading && loadedPages === 0) || isReseting || isDeleting ? (
                    <LinearProgress />
                ) : (
                    <>
                        <ManagersTable
                            isFetching={isLoading || isReseting}
                            managersData={rows}
                            onDelete={handleDelete}
                            onResetPassword={handleResetPassword}
                        />

                        <Sentinel ref={sentinelRef} isLoading={isLoading} />
                    </>
                )}
            </Content>
        </Wrapper>
    )
}

export default ManagerListPage
